module.exports = __webpack_public_path__ + "static/media/add.ec2005ec.svg";